<div class="table-responsive"
     [ngClass]="{'filter-row-on-top': hasFilterOnTop()}"
     [class.overflow-hidden]="stripeAccountsService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': stripeAccountsService.data.data.length < 2}">
                <th>
                    <label class="img-checkbox">
                        <input type="checkbox" id="allChecked" [(ngModel)]="allChecked" (ngModelChange)="checkAll($event)">
                        <label for="allChecked"><svg-checked></svg-checked></label>
                    </label>
                </th>
                <th (click)="orderBy('net', $event)">
                    Net <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('fee', $event)">
                    Fee <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('refunded', $event)">
                    Refunded <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('bookingId', $event)">
                    Booking ID <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('amenityName', $event)">
                    Amenity <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('buildingName', $event)">
                    Building Name <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('suiteNumber', $event)">
                    Suite Number <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('residentName', $event)">
                    Resident Name <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('hasPayout', $event)">
                    Status <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted">
                    Created At <span class="footable-sort-indicator"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="stripeAccountsService.data.data" let-index="index">
                <tr (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td class="text-right">{{item.net | currency}}</td>
                    <td class="text-right">{{item.fee | currency}}</td>
                    <td class="text-right">{{item.refunded | currency}}</td>
                    <td class="text-right">{{item.bookingNumber}}</td>
                    <td>{{item.amenityName}}</td>
                    <td>{{item.buildingName}}</td>
                    <td>{{item.suiteNumber}}</td>
                    <td>{{item.residentName}}</td>
                    <td>
                        <span class="label label{{item.hasPayout ? '' : '-not'}}-payouted">
                            {{item.hasPayout ? 'Paid Out' : 'Not Paid Out'}}
                        </span>
                    </td>
                    <td>{{item.createdAt | mccDate:true:true}}</td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of stripeAccountsService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!stripeAccountsService.data.total"
                          [isServiceUnavailable]="stripeAccountsService.showServiceUnavailable"
                          [isLoading]="stripeAccountsService.spinnerShow">
        You have no {{stripeAccountsService.selectedTab}} listed on the system<br>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-transactions-list/stripe-transactions-list.component.html